module.exports = __webpack_public_path__ + "static/media/virus (6).c039b69d.png";